import { getTargetOf, getHashFrom } from './scroll-context';

const quickLinks = document.querySelectorAll<HTMLAnchorElement>(
	'a[data-quick-link][href^="#"]',
);

quickLinks.forEach((link) => {
	link.addEventListener('click', (ev) => {
		const hash = getHashFrom(link);
		const target = getTargetOf(link);
		if (target == null) return;

		ev.preventDefault();

		target?.scrollIntoView({ behavior: 'smooth' });
		if (hash) {
			history.replaceState('', '', hash);
		}
	});
});
